import React from "react";
import './education.css'

const Education=()=>{
    return(
        <section id="education">
            <span className="educationTitle">Education</span><br />
            <div className="educationBars">
            <div className="educationBar">
            <div className="educationBarText">
                <h2 className="degree">Bachelor of Science in Information Technology-Bsc.IT</h2>
                <p>Arumugam Pillai Seethai Ammal Collage, Tiruppathur</p><br />
                <h2 className="year">2020-2023</h2>
                <p>I completed my undergraduate studies at Arumugam Pillai Seethai Ammal Collage, achieving first-class honors with a 70% score. The college provided a robust academic foundation, emphasizing both theoretical knowledge and practical skills. The faculty were highly supportive, fostering a deep understanding of my field of study.</p>
            </div>
            </div>
            </div> 

            <div className="educationBars">
            <div className="educationBar">
            <div className="educationBarText">
                <h2 className="degree">Higher Secondary School Certificate - HSSC</h2>
                <p>MK Government Higher Secondary School Sembanur,Sivagangai</p><br />
                <h2 className="year">2018-2020</h2>
                <p>I completed my Higher Secondary School Certificate (HSSC) achieving a percentage of 53%. During my HSSC studies, I focused on a comprehensive curriculum that laid a solid foundation for my academic and professional journey. The rigorous coursework honed my analytical skills, critical thinking, and problem-solving abilities.</p>
            </div>
            </div>
            </div> 

            <div className="educationBars">
            <div className="educationBar">
            <div className="educationBarText">
                <h2 className="degree"> Secondary School Leaving Certificate - SSLC</h2>
                <p>MK Government Higher Secondary School Sembanur,Sivagangai</p><br />
                <h2 className="year">2017-2018</h2>
                <p>I completed my Secondary School Leaving Certificate (SSLC) achieving a percentage of 74%. My SSLC education provided a strong foundation in various subjects, fostering a well-rounded academic experience. The rigorous coursework and dedicated teachers helped develop my critical thinking, problem-solving skills, and a strong work ethic.</p>
            </div>
            </div>
            </div> 
        </section>
    )
}
export default Education